import { State, initialState } from './public.state';
import { publicActionTypes, Actions } from './public.actions';

// eslint-disable-next-line @typescript-eslint/default-param-last
export function PublicReducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case publicActionTypes.SetPrivateLabelHeaderLogo: {
      return Object.assign({}, state, { privateLabelLogo: action.payload });
    }
    default: {
      return state;
    }
  }
}
